module.exports = __webpack_public_path__ + "img/aussen1.fdad64c2.jpg";